var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionRouteDirectionHere({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z",
    clipRule: "evenodd",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10h2v7h-2v-7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.727c0 .176.064.346.18.479l3.021 3.453a1 1 0 0 0 .753.341h.092a1 1 0 0 0 .753-.341l3.021-3.453A.727.727 0 0 0 15.273 17H8.727a.727.727 0 0 0-.727.727Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm2 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionRouteDirectionHere);
export default __webpack_public_path__ + "static/media/ic_action_route_direction_here.7c804ab76b0701852469b95fcc4e3423.svg";
export { ForwardRef as ReactComponent };